import { getAnalyticsItems } from '@src/domains/analytics/core/getAnalyticsItems';
import { getSaleItems, type Sale } from '@src/domains/sales';

export const getSaleAnalyticsData = (sale: Sale) => {
  const items = getAnalyticsItems(getSaleItems(sale));

  return {
    saleId: sale.id,
    items,
    itemsCount: items.length,
    value: sale.totalAmountCents / 100,
    paymentMethod: sale.lastTransaction?.paymentMethod.code,
  };
};
